<template>
  <a-drawer width="35%" :visible="visible" @close="onClose">
    <a-divider orientation="left">
      <b>{{ $t('回收结算') }}</b>
    </a-divider>
    <a-alert :message="$t('打款至用户钱包不可撤销，请确认金额无误')" type="warning" show-icon style="margin-bottom: 16px;" />
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('单号')">
        <span>{{ current.orderNo }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('联系人')">
        <span>{{ current.contactName }}（{{ current.contactPhone }}）</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('报价金额')">
        <span>{{ current.quoteAmount }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('结算金额')" prop="settleAmount">
        <a-input-number v-model="form.settleAmount" :min="0.01" :precision="2" style="width: 100%" :placeholder="$t('请输入')+$t('结算金额')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('处理备注')" prop="handleRemark">
        <a-input v-model="form.handleRemark" :maxLength="500" :placeholder="$t('请输入')+$t('处理备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('确认打款')}}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { settleRecycleOrder } from '@/api/recycle/order'

export default {
  name: 'SettleForm',
  data () {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      submitLoading: false,
      visible: false,
      current: {},
      form: {
        id: null,
        settleAmount: null,
        handleRemark: null
      },
      rules: {
        settleAmount: [{ required: true, message: '请输入结算金额', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open (record) {
      this.current = record
      this.form = {
        id: record.id,
        settleAmount: record.quoteAmount,
        handleRemark: null
      }
      this.visible = true
    },
    onClose () {
      this.visible = false
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          settleRecycleOrder(this.form).then(response => {
            this.$message.success(this.$t('结算成功'), 3)
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
